import { useEffect, useState } from "react";
import { getAllGroup } from "./customerGroupingApi";
import { Fab, Grid } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import UserCard from "../../common/searchModal/userCard";
import AddCategories from "./addGropmodal";

export const GroupingCustomer = () => {
  const [open, setOpen] = useState(false);

  const [collection, setCollection] = useState([]);
  useEffect(() => {
    getAllGroup((data) => {
      console.log("groupalldata", data);

      setCollection(data?.data?.list);
    });
  }, []);
  return (
    <Grid
      container
      spacing={1}
      sx={{
        padding: "20px",
      }}
    >
      <Grid
        item
        xs={12}
        sx={{
          textAlign: "right",
        }}
      >
        <Fab
          onClick={() => {
            // setOpen(true);

            setOpen(true);
          }}
          sx={{
            textTransform: "capitalize",
            width: {
              xs: "100%",
              sm: "auto",
            },
            // p: "10px",
            whiteSpace: "nowrap",
          }}
          size="small"
          color="primary"
          variant="extended"
          aria-label="add"
        >
          Add Customer Group
          <AddIcon />
        </Fab>
      </Grid>

      {collection.map((ele, index) => {
        return (
          <Grid item xs={12} sm={6} lg={4}>
            <UserCard 
               key={"employee" + index}
              data={{ 
                ...ele,
                name: (
                  <span>
                    <span style={{ color: "black"}}>Group Name:</span>{" "}
                    {ele.customerGroupName}
                  </span>
                ),
                // customerMobile: "Number of Items",
              }}
              callBack={() => {
                //   setOpen(true)
                //   setFormDataModal(item)
                // setOpen(true)
              }}
            />
          </Grid>
        );
      })}

      <AddCategories open={open} setOpen={setOpen} />
    </Grid>
  );
};
